/**
 * 等级体系 v3 (LevelUp 2.0) API
 * 路由前缀: /api/v3/tier
 * 与现有 /api/v2 完全独立
 */
import axios from 'axios';

const TIER_API_BASE = '/api/v3/tier';

const tierClient = axios.create({
  baseURL: TIER_API_BASE,
  headers: { 'Content-Type': 'application/json' },
  timeout: 10000,
});

// 注入 token
tierClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// === API 调用 ===

export const getTierConfig = async () => {
  const res = await tierClient.get('/config');
  return res.data;
};

export const getAllLevels = async () => {
  const res = await tierClient.get('/levels');
  return res.data;
};

export const getMyTier = async (userId) => {
  if (!userId) throw new Error('userId is required');
  const res = await tierClient.get(`/me/${userId}`);
  return res.data;
};

export const getMySettlements = async (userId, page = 1, pageSize = 20) => {
  if (!userId) throw new Error('userId is required');
  const res = await tierClient.get(`/settlements/${userId}`, {
    params: { page, page_size: pageSize },
  });
  return res.data;
};

export const adjustUserTier = async (userId, targetCode, reason) => {
  const res = await tierClient.post(`/adjust/${userId}`, {
    target_code: targetCode,
    reason: reason || 'manual_adjust',
  });
  return res.data;
};

export const settleUser = async (userId, period) => {
  const res = await tierClient.post(`/settle/${userId}`, period ? { period } : {});
  return res.data;
};

export const settleAllUsers = async (period) => {
  const res = await tierClient.post('/settle-all', period ? { period } : {});
  return res.data;
};

// === 前端常量（与后端 tier_models 保持一致） ===

export const TIER_KEYS = ['free', 'bronze', 'silver', 'gold', 'platinum', 'diamond'];

export const TIER_DISPLAY = {
  free:     { name: '免费会员', color: '#9E9E9E', icon: '🌱', tier: 1 },
  bronze:   { name: '青铜会员', color: '#CD7F32', icon: '🥉', tier: 2 },
  silver:   { name: '白银会员', color: '#C0C0C0', icon: '🥈', tier: 3 },
  gold:     { name: '黄金会员', color: '#FFD700', icon: '🥇', tier: 4 },
  platinum: { name: '铂金会员', color: '#E5E4E2', icon: '🏆', tier: 5 },
  diamond:  { name: '钻石会员', color: '#B9F2FF', icon: '💎', tier: 6 },
};

export const POINTS_PER_LEVEL = 100;

// === 工具函数 ===

export const codeToLabel = (code) => {
  if (!code || code < 11 || code > 69) return 'Lv1.1';
  return `Lv${Math.floor(code / 10)}.${code % 10}`;
};

export const tierFromCode = (code) => {
  if (!code) return TIER_DISPLAY.free;
  const tierNum = Math.floor(code / 10);
  const key = TIER_KEYS[tierNum - 1] || 'free';
  return { ...TIER_DISPLAY[key], key };
};
